import { render } from "./CursosMatriculadosCard.vue?vue&type=template&id=5b82acf0"
import script from "./CursosMatriculadosCard.vue?vue&type=script&lang=js"
export * from "./CursosMatriculadosCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__